import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { FORM, REPORT } from "services/apiEndpoints";
import { privateDelete, privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
    report: [],
    selectedReport: null,
    reportModalOpen: false,
    isFetching: false,
    allReports: [],
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
    reportData: [],
    originalData: [],
    reportContentId: {},
    reportFilters: {},
    exportAllData: {},
    exportFilteredData: {},
       sortBy: "",                   
  sortOrder: "",   
    filterApplied: false,
}

const SECTION = 'section'

export const getAllReportsData = createAsyncThunk("report/getReportData", async (payload, { rejectWithValue, dispatch, signal }) => {
    try {

        const queryString = makeQueryString(`${FORM}`, payload);
        const { data } = await privateGet(queryString, { signal });
        // console.log('data', data)
        dispatch(setPageNumber(payload.pageNumber));
        dispatch(setPageSize(payload.limit));
        return {
            report: data?.data?.forms || [],
            totalCount: data?.data?.totalForms || 0,
        };
    } catch (error) {
        rejectWithValue(error);
        return error;
    }
})


const getConvertedField = (field, sectionId) => {
    return {
        ...field,
        name: field.type || field.name,
        type: field.type || SECTION,
        data: {
            id: field._id,
            media: field?.media
                ? [
                    ...field?.media?.map((e) => {
                        return {
                            path: e,
                        };
                    }),
                ]
                : null,
            ...(field?.options ? { options: field?.options } : {}),

            value: field.label || field.name || "",
            required: field.required || false,
        },
        id: field._id,
        sectionId,
    };
};

export const convertMyTreeToList = (tree) => {

    const innerFields = tree.fields.map((field) =>
        getConvertedField(field, 0)
    );
    tree.sections.forEach(({ fields, ...field }) => {
        innerFields?.push(getConvertedField(field, field._id));
        fields.forEach((innerField) => {
            innerFields?.push(getConvertedField(innerField, field._id));
        });
    });

    return innerFields
}

export const getReportsDataById = createAsyncThunk("report/getReportData/id", async (datas, { rejectWithValue, dispatch, signal }) => {
    try {
        const { id, payload } = datas

        const queryString = makeQueryString(`${FORM}/${id}/response`, payload);
//         const queryString = makeQueryString(`${FORM}/${id}/response`, {
//   ...payload,
//   sortBy: payload.sortBy || "",
//   sortOrder: payload.sortOrder || "",
// });
        const { data } = await privateGet(queryString, { signal });
        // console.log('data', data)
        dispatch(setPageNumber(payload.pageNumber));
        dispatch(setPageSize(payload.limit));
        let outerFields = []

        data?.data?.responses?.forEach((report, index) => {

            const innerFields = convertMyTreeToList(report)
            // console.log('{innerFields}', { innerFields })
            let innerObject = innerFields?.filter((e) => e?.label || e?.type !== "section")?.reduce((acc, cr) => {
                acc[cr?.label] = cr?.mediaResponse?.length > 0 ? cr?.mediaResponse : cr?.value
                return acc
            }, {})
            outerFields?.push(innerObject)
        })

        const originalData = convertMyTreeToList(data?.data?.responses[0])
        return {
            totalCount: data?.data?.totalResponses || 0,
            report: {
                outerField: outerFields || [],
                originalData: originalData || []
            },
        };
    } catch (error) {
        rejectWithValue(error);
        return error;
    }
})
// console.log(reportFilters);

// export const getAllReportsData = createAsyncThunk("report/getAllReportsData", async () => {
//     // api call here
// })

// export const deleteReport = createAsyncThunk("entity/deleteReport", async (id, { dispatch }) => {
//     await privateDelete(REPORT, id)
//     dispatch(getReportData())
//     toast.success("Report deleted successfully")
// })

const reportSlice = createSlice({
    name: "report",
    initialState,
    reducers: {
        setExportAllData: (state, action) => {
            state.exportAllData = action.payload;
        },
        setExportFilteredData: (state, action) => {
            state.exportFilteredData = action.payload;
        },
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setReportsFilters: (state, action) => {
            state.reportFilters = action.payload
        },
        setFilterApplied: (state, action) => {
            state.filterApplied = action.payload
        },
        setSelectedReport: (state, action) => {
            state.selectedReport = action.payload
            state.reportModalOpen = !!action.payload
        },
        setReportModalOpen: (state, action) => {
            state.reportModalOpen = action.payload
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setOriginalData: (state, action) => {
            state.originalData = action.payload;
        },
        setReportContentId: (state, action) => {
            state.reportContentId = action.payload;
        },
        setSortBy: (state, action) => {
  state.sortBy = action.payload;
},
setSortOrder: (state, action) => {
  state.sortOrder = action.payload;
},

    },
    extraReducers: {
        [getAllReportsData.pending]: (state, action) => {
            state.isFetching = true
        },
        [getAllReportsData.fulfilled]: (state, action) => {
            state.report = action.payload.report
            state.totalCount = action.payload.totalCount
            state.isFetching = false
        },
        [getAllReportsData.rejected]: (state, action) => {
            state.isFetching = false
        },
        [getReportsDataById.pending]: (state, action) => {
            state.isFetching = true
        },
        [getReportsDataById.fulfilled]: (state, action) => {
            state.reportData = action.payload.report?.outerField
            state.originalData = action?.payload?.report?.originalData || []
            state.totalCount = action.payload.totalCount
            state.isFetching = false
        },
        [getReportsDataById.rejected]: (state, action) => {
            state.isFetching = false
        },
    }
})

export default reportSlice.reducer
export const { setIsFetching, setExportAllData, setExportFilteredData, setReportsFilters, setFilterApplied, setReportContentId, setPageNumber, setPageSize, setOriginalData, setSelectedReport, setReportModalOpen,  setSortBy,
  setSortOrder } = reportSlice.actions